import { useTranslation } from 'react-i18next';

import { Section } from 'components/Display/Section/Section';

import { PreferredUnitItem } from '../../PreferredUnitItem/PreferredUnitItem';
import { ReadOnlyIndicator } from './ReadOnlyIndicator';

type UnitsOfMeasureSectionProps = {
  units: Array<string>;
};

export const UnitsOfMeasureSection = ({ units }: UnitsOfMeasureSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section.Horizontal
      title={t('settings:documentUnderstandingAgent.global.unitsOfMeasure.title')}
      description={t('settings:documentUnderstandingAgent.global.unitsOfMeasure.description')}
      action={<ReadOnlyIndicator />}
    >
      {units.length > 0 ? (
        <ol className="flex flex-col gap-2">
          {units.map((unit, index) => (
            <PreferredUnitItem key={`${unit}-${index}`} order={index + 1} unitOfMeasure={unit} />
          ))}
        </ol>
      ) : (
        <span className="text-sm text-gray-400">
          {t('settings:documentUnderstandingAgent.global.unitsOfMeasure.empty')}
        </span>
      )}
    </Section.Horizontal>
  );
};
